import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

import { AreaRecord } from '../../../entities/records';
import * as styles from './styles.css';
import { ButtonSmall } from '../../Button/index';
import { withTranslation } from 'react-i18next';

const DEFAULT_DISTANCE_KM = 10;

function optionIcon({ coordinates }) {
  if (coordinates) {
    return 'fa-map-marker';
  }

  return 'fa-square';
}

function optionRenderer(option) {
  return (
    <div className={styles.option}>
      <div>
        {option.label}
        {option.secondaryName && (
          <div className={styles.secondary}>{option.secondaryName}</div>
        )}
      </div>
      <i className={`fa fa-lg ${optionIcon(option.value)}`} />
    </div>
  );
}

function valueToOption(geoCode) {
  if (!geoCode) {
    return geoCode;
  }

  return {
    label: geoCode.name,
    secondaryName: geoCode.secondaryName,
    value: geoCode,
    geoCode: geoCode.id,
  };
}

function optionToValue(option) {
  if (!option || (Array.isArray(option) && option.length === 0)) {
    return null;
  }

  const geoCode = option.value;
  geoCode.set('geoCode', geoCode.geoCode)
  return geoCode.set('distance', geoCode.type === 'point' ? DEFAULT_DISTANCE_KM : geoCode.distance);
}

function setDistance(geoCode, distance) {
  return geoCode.set('distance', parseInt(distance, 10) || 0);
}

class GeoSearchRow extends Component {
  options = () => this.props.geoCodes.map(valueToOption); // remapping

  render() {
    let shouldShowDistance = this.props.input.value && (this.props.input.value.type == 'point' || !this.props.input.value.geoCode);
    if (this.props.input.value && (this.props.input.value.type == 'polygon' || this.props.input.value.type == 'multipolygon')) {
      shouldShowDistance = false;
    }
    const { i18n } = this.props;

    return (
      <div className={styles.geoSearchRowContainer}>
        <Select
          className={styles.searchInput}
          name="geo-search-row"
          placeholder={i18n.t("Plats, ort, län, landsting osv...")}
          autoload={false}
          disabled={this.props.disabled}
          options={this.options()}
          optionRenderer={optionRenderer}
          onChange={(option) => {
            this.props.input.onChange(optionToValue(option))
          }}
          onBlur={() => this.props.input.onBlur(this.props.input.value)}
          onInputChange={this.props.onInputChange}
          value={valueToOption(this.props.input.value)}
          isLoading={this.props.isLoading}
          filterOptions={false}
        />
        {shouldShowDistance &&
          (
            <input
              disabled={!this.props.input.value}
              className={`form-control ${styles.distanceInput}`}
              type="number"
              placeholder="Avstånd i km"
              value={this.props.input.value &&
                (this.props.input.value.distance ? this.props.input.value.distance : '')}
              onChange={event =>
                this.props.input.onChange(setDistance(this.props.input.value, event.target.value))
              }
            />
          )}
        <ButtonSmall icon="trash" iconStyle="danger" onClick={this.props.removeAction} />
      </div>
    );
  }
}

GeoSearchRow.defaultProps = {
  geoCodes: [],
  disabled: false,
};

GeoSearchRow.propTypes = {
  geoCodes: PropTypes.arrayOf(PropTypes.instanceOf(AreaRecord)),
  input: PropTypes.shape({
    value: PropTypes.instanceOf(AreaRecord),
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
  }).isRequired,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool.isRequired,
  onInputChange: PropTypes.func.isRequired,
  removeAction: PropTypes.func.isRequired,
};

export default withTranslation()(GeoSearchRow);
